import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { axios } from "../../../lib";
import { customToast as toast } from "../../../utils";

import CustomerService from "../../../services/customerService";

import HeaderWrapper from "../../common/HeaderWrapper";
import ItglueAssetList from "./ItglueAssetList";

const INITIAL_PAGINATION = {
  currentPage: null,
  totaPages: null,
  pageSize: 50
};

const CustomerItgluePage = ({ isMobile, auth }) => {
  const [loading, setLoading] = useState(false);
  const [assets, setAssets] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [pagination, setPagination] = useState(INITIAL_PAGINATION);

  const { id, assetType } = useParams();

  useEffect(() => {
    setLoading(true);
    const fetchCustomer = async () => {
      const customerData = await CustomerService.getCustomer(id);
      setCustomer(customerData);
    };

    fetchCustomer();
  }, [id, assetType]);

  const fetchData = useCallback(
    async (page = 1, pageSize = 50) => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `/api/itglue/getOrganizationAssets/${customer.itglue_id}/${assetType}/${auth.username}/${page}/${pageSize}`
        );
        if (data.data) {
          setAssets(data.data);
          if (data.meta) {
            setPagination({
              currentPage: data.meta["current-page"] - 1,
              totaPages: data.meta["total-pages"],
              pageSize: data.data.length
            });
          }
        } else {
          setAssets([]);
        }
      } catch ({ response }) {
        setAssets([]);
        if (response.data.errors) {
          toast.error(response.data.errors.message);
        }
      }
      setLoading(false);
    },
    [assetType, auth.username, customer.itglue_id]
  );

  useEffect(() => {
    if (customer?.itglue_id) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [id, assetType, customer?.itglue_id, fetchData]);

  const handlePageChange = (page) => {
    fetchData(page + 1, pagination.pageSize);
  };

  const handlePageSizeChange = (size) => {
    fetchData(1, size);
  };

  return (
    <div id="itglue">
      <HeaderWrapper
        breadcrumbs={[
          { label: customer?.name },
          { label: `ITGlue ${assetType}` }
        ]}
        isMobile={isMobile}
      />
      <ItglueAssetList
        data={assets}
        loading={loading}
        assetType={assetType}
        sorted={[{ id: "name", desc: false }]}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        page={pagination.currentPage}
        pages={pagination.totaPages}
        pageSize={pagination.pageSize}
        isMobile={isMobile}
      />
    </div>
  );
};

CustomerItgluePage.propTypes = {
  isMobile: PropTypes.bool,
  auth: PropTypes.object
};
function mapStatesToProps(state) {
  return {
    auth: state.reducers.auth
  };
}

export default connect(mapStatesToProps)(CustomerItgluePage);
